enum CaptchaEvent {
    EXECUTE = 'captcha:execute',
    SUCCESS = 'captcha:success',
    ERROR = 'captcha:error',
    EXPIRE = 'captcha:expire'
}

export default CaptchaEvent;
